<template>
<div class="col-md-11 col-xs-11" style="margin-left: 4%">
  <mdb-carousel
    :items="getPCCount()"
    multi
    controlls
    indicators
    :interval="5000"
    
  >
  <template #[i+1] v-for="(o, i) in private_community">
      <mdb-card :key="i" style='box-shadow: none;'>
        <mdb-card-image
          :src="o && o.banner && o.banner[0]"
          alt="Card image cap"
        ></mdb-card-image>
        <mdb-card-body>
          <mdb-card-text style="color: #4B2D15;font: Bold 17px/21px Proxima Nova;">{{o.name}}</mdb-card-text>
          <mdb-card-text
            ><img src="../../assets/images/community/ic_khoilop.svg" style="height: 16px; margin-left: -47%;"><span style="height: 16px; color: #3A9F00;  margin-left: -45%; font: Regular 13px/16px Proxima Nova;">{{o.subject.name}}</span></mdb-card-text
          >
          <mdb-card-text
            ><img src="../../assets/images/community/ic_thanhvien.svg" style="height: 16px; margin-left: -47%;"><span style="height: 16px; color: #4B2D15;  margin-left: -45%; font: Regular 13px/16px Proxima Nova;">{{o.pc_users.length}} thành viên</span></mdb-card-text
          >
        </mdb-card-body>
      </mdb-card>
    </template>
  </mdb-carousel>
  </div>
</template>

<script>
import { mdbCarousel, mdbCard, mdbCardImage, mdbCardText, mdbCardBody, mdbBtn } from 'mdbvue'
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
export default {
  name: 'CarouselPage',
  components: {
    mdbCarousel,
    mdbCard,
    mdbCardImage,
    mdbCardText,
    mdbCardBody,
    mdbBtn
  },
  data() {
    return {
      private_community: null,
      count: 0
    }
  },
  methods: {
    getPCCount() {
      if (this.private_community && this.private_community.length > 4) {
        return 4
      } else {
        return this.private_community && this.private_community.length || 0
      }
    }
  },
  apollo: {
    private_community: {
      query: gql(graphql.GET_PRIVATE_COMMUNITY),
      variables() {
        return {
          user_id: this.$store.getters.user
        }
      },
      update: data => {
        // console.log(data.private_community)
        return data.private_community
      }
    }
  }
}
</script>
<style lang="scss">
.carousel-indicators li {
  border: 1px solid #969FAD !important;
}
.carousel-indicators {
  bottom: -4% !important;
}
.carousel-indicators .active {
  background-color: #969FAD !important;
}
@media screen and (min-width: 768px){
  .carousel-indicators {
    bottom: -4% !important;
  }
}
.carousel .carousel-control-prev-icon {
    background-image: url(../../assets/chevron_left.svg);
    width: 35px;
    height: 35px;
    background-size: 30px;
    cursor: pointer;
}
.carousel .carousel-control-next-icon {
    background-image: url(../../assets/chevron_right.svg);
    width: 35px;
    height: 35px;
    background-size: 30px;
    cursor: pointer;
}
.carousel-control-prev{
  z-index: 1000;
  left: 0;
  position: absolute;
  top: 25px;
  bottom: 106px;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 15%;
  color: #969FAD;
  text-align: center;
  opacity: .5;
  transition: opacity .15s ease;
}
.carousel-control-next{
  z-index: 1000;
  right: 0;
  position: absolute;
  top: 25px;
  bottom: 106px;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 15%;
  color: #969FAD;
  text-align: center;
  opacity: .5;
  transition: opacity .15s ease;
}
.img-fluid {
  height: 160px !important;
}
</style>



// WEBPACK FOOTER //
// CommunityTeacher.vue?6c3e9c3c